import React from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const normalizeVariant = (variant) => {
  const allowed = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'light'];
  return allowed.includes(variant) ? variant : 'primary';
};

export const mapTenantNotificationsToDropdownItems = (data, { lupa, lupav, onOpenModal } = {}) => {
  const rows = Array.isArray(data) ? data : [];

  return rows.map((notificacao) => {
    const isLida = notificacao?.data_hora_leitura !== 'null' && notificacao?.data_hora_leitura !== null;

    const dh = notificacao?.data_hora_inicio;
    const dhText = dh && typeof dh.toLocaleString === 'function' ? dh.toLocaleString('pt-BR', { timeZone: 'UTC' }) : '';

    const variant = normalizeVariant((notificacao?.fundo || '').toString().trim());
    const cardClass = `mb-2 border-left border-${variant} ${!isLida ? 'bg-light' : ''}`;

    const hasLink = notificacao.link !== null && notificacao.link !== 'null';
    const rawLink = hasLink ? String(notificacao.link || '').trim() : null;
    const href = rawLink ? (rawLink.startsWith('tickets/') ? `/${rawLink}` : rawLink) : null;
    const isInternal = href ? href.startsWith('/') : false;

    return (
      <ListGroup.Item as='li' bsPrefix=' ' className='notification' key={notificacao.key}>
        <Card
          className={cardClass}
          style={{ cursor: 'pointer' }}
          onClick={() => onOpenModal && onOpenModal({ ...notificacao, dhText, variant })}
        >
          <Card.Body className='p-2'>
            <div className='d-flex justify-content-between align-items-start'>
              <div className='pr-2'>
                <div className={`m-0 ${!isLida ? 'font-weight-bold' : ''}`}>{notificacao.titulo}</div>
              </div>
              {lupa && lupav ? (
                <img src={isLida ? lupav : lupa} width={15} alt={isLida ? 'Lida' : 'Não lida'} />
              ) : null}
            </div>

            <p className='mb-1 text-muted' style={{ fontSize: '13px' }}>
              {notificacao.texto}
            </p>

            <div className='d-flex justify-content-between align-items-center'>
              <span className='text-muted f-10'>{dhText}</span>
              {hasLink && (
                isInternal ? (
                  <Link
                    to={href}
                    className='rounded badge-light-success p-1'
                    style={{ fontSize: '12px' }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    Visualizar
                  </Link>
                ) : (
                  <a
                    target='_blank'
                    href={href}
                    className='rounded badge-light-success p-1'
                    style={{ fontSize: '12px' }}
                    rel='noreferrer'
                    onClick={(e) => e.stopPropagation()}
                  >
                    Visualizar
                  </a>
                )
              )}
            </div>
          </Card.Body>
        </Card>
      </ListGroup.Item>
    );
  });
};
